<template>
<div>
	<div v-if="showList">
		
		<collapsible-panel :external-toggle="filterPanelVisible" panel-size="md" v-on:panelRetract="filterPanelVisible = false">
			<template slot="panel">
				
				<h4>Filtering</h4>

				<template v-if="isMainList">
					<field
						label="Project" 
						col-class="stacked"  
						v-model="filterValues.job_id" 
						:params="{type:'select',options: jobOptions}"
						v-on:change="filtersChanged">
					</field>

					<field
						label="Service" 
						col-class="stacked" 
						v-model="filterValues.service_id" 
						:params="{type:'select',options: serviceOptions}"
						v-on:change="filtersChanged">
					</field>
				</template>

				<form-group label="Date Range (from-to)" col-class="stacked">
					<div class="d-flex flex-row">

						<field v-model="filterValues.dateFrom" :params="{type:'date'}" v-on:change="filtersChanged"></field>

						<field v-model="filterValues.dateTo" :params="{type:'date'}" v-on:change="filtersChanged"></field>

					</div>

				</form-group>

			</template>
			<template slot="main">
				<table-list
					:fields="fields"
					:records="mutatedPOs"
					record-name="Purchase Order"
					:sortable="true"
					:has-edit="true"
					:has-delete="true"
					delete-endpoint="PurchaseOrder/delete"
					id-field="slug"
					:hide-record-count="true"
					:other-buttons="[
						{
							condition: ['hasSingleExpense',true],
							click: 'viewAssociatedExpense',
							text: 'View Expense',
							class: 'btn-light',
							icon: 'fa-eye'
						},
						{
							condition: ['hasMultipleExpenses',true],
							click: 'viewAssociatedExpenses',
							text: 'View Expenses',
							class: 'btn-light',
							icon: 'fa-eye'
						}
					]"
					v-on:edit="editPO"
					v-on:modelChange="fetchPOs(true)"
					v-on:viewAssociatedExpense="viewAssociatedExpense"
					v-on:viewAssociatedExpenses="viewAssociatedExpenses">

					<div class="d-flex justify-content-between">
						<h2>
							Purchase Orders

							<div v-if="!isMainList">
								<small v-if="isServicePo" class="text-muted">Service #{{$store.service.job_num}}</small>
								<small v-else class="text-muted">Project #{{$store.project.job_num}}</small>
							</div>
						</h2>

						<div>
							<button class="btn btn-light mr-2" :disabled="filterPanelVisible" v-on:click="openFilterPanel">
								<i class="fa fa-filter"></i>
								Filter
							</button>

							<button class="btn btn-success" v-on:click="newPO">
								<i class="fa fa-plus"></i>
								New Purchase Order
							</button>
						</div>
					</div>
				</table-list>

				<div class="text-center" v-if="mutatedPOs.length > 0 && numPages > pageNum">
					<button class="btn btn-light" type="button" v-on:click="loadMore">
						Load More
					</button>
				</div>
			</template>
		</collapsible-panel>
	</div>
	<collapsible-panel v-else :always-open="true" panel-size="sm">
		<template slot="panel">
			<h3>Purchase Order</h3>

			<panel-menu 
				:menu-items="menuItems"
				:active-item="activeSection"
				v-on:itemClick="activateSection">
			</panel-menu>

			<div v-if="activeSection == 'Files' || activeSection == 'Finalizing'" class="d-flex flex-column mt-4">
				<h4>Filter Files</h4>

				<label v-for="tag in fileTags">
					<input type="checkbox" v-model="selectedFileTags" :value="tag">
					{{tag}}
				</label>

			</div>
		</template>
		<template slot="main">
			<i class="fa fa-times icon-button close-edit" v-on:click="backToList"></i>

			<p><a :href="backUrl" v-on:click.prevent="backToList">
				<i class="fa fa-arrow-left"></i>
				Back to Purchase Orders
			</a></p>

			<div class="row">
				<div v-if="activeSection != 'Delivery'" class="col-lg-6">
					
					<vue-form
						v-on:submit="savePO(false)" 
						size="sm" 
						:no-top-button="true" 
						:save-button-fixed="true"
						:working="working">

						<div v-show="activeSection == 'Details'">

							<template v-if="isMainList">
								<field v-if="!selectedPO.service_id"
									label="Project"
									col-class="col-sm-4 col-md-4 col-lg-3"
									:params="{type:'select',options:jobOptions}"
									:readonly="isFinalized"
									v-model="selectedPO.job_id"
									v-on:change="jobSelected($event,'Job')">
								</field>

								<field v-if="!selectedPO.job_id"
									label="Service"
									col-class="col-sm-4 col-md-4 col-lg-3"
									:params="{type:'select',options:serviceOptions}"
									:readonly="isFinalized"
									v-model="selectedPO.service_id"
									v-on:change="jobSelected($event,'Service')">
								</field>
							</template>	

							<field v-if="'id' in selectedPO" 
								label="Status" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:poStatusOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.status">
							</field>
						
							<field label="PO Date" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'date',initialDate:'today'}"
								:readonly="isFinalized"
								v-model="selectedPO.po_date">
							</field>

							<field label="Subject" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:readonly="isFinalized"
								v-model="selectedPO.subject">
							</field>

							<field label="Supplier" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:supplierOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.supplier_id"
								v-on:change="supplierChange">
							</field>

							<field v-if="selectedPO.supplier_id > 0" 
								label="Supplier Contact" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:supplierContactOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.supplier_contact_id">
							</field>

							<field v-if="supplierLocationOptions.length > 0" 
								label="Supplier Location" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:supplierLocationOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.supplier_location_id">
							</field>

							<field label="Site Contact" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:usersWithRolesOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.site_contact_id">
							</field>

							<field label="Issued By" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:usersWithRolesOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.issued_by_id">
							</field>

							<field label="Ship To" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'select',options:addressOptions}"
								:readonly="isFinalized"
								v-model="selectedPO.ship_to_address_json">
							</field>

							<field label="Instructions" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'richtext'}"
								:readonly="isFinalized"
								v-model="selectedPO.instructions"
								v-on:input="richTextChange">
							</field>

							<field label="Terms & Conditions" 
								col-class="col-sm-4 col-md-4 col-lg-3"
								:params="{type:'richtext'}"
								:readonly="isFinalized"
								v-model="selectedPO.terms"		
								v-on:input="richTextChange">
							</field>

						</div>
						<div v-show="activeSection == 'Order Items'">

							<table-list
								record-name="Item"
								:fields="[
									{label: 'Description',key:'description'},
									{label: 'Part Number', key:'part_number'},
									{label: 'Supplier PN', key:'supplier_number'},
									{label: 'Qty',key:'qty',align:'right'},
									{label: 'Unit',key:'unit_type'},
									{label: 'Unit Price',key:'unitPriceFormatted',align:'right'}
								]"
								:records="mutatedPOItems"
								:has-delete="!isFinalized"
								:simple-delete="true"
								:has-edit="!isFinalized"
								:rows-draggable="true"
								:has-drag-handle="true"
								v-on:edit="editItem"
								v-on:delete="removeItem"
								v-on:dragEnd="updateItemOrder">
							</table-list>

							<div v-if="!isFinalized" class="float-right">
								<button class="btn btn-success mr-1" v-on:click="addFreeformItem" type="button">
									<i class="fa fa-plus"></i>
									Add Item
								</button>
								<button class="btn btn-success" v-on:click="addMaterialsFromEstimate" type="button">
									<i class="fa fa-plus"></i>
									Add Materials
								</button>
							</div>
						</div>
						<div v-show="activeSection == 'Files'">
							<outbound-document-files-tab
								:record-id="'id' in selectedPO ? selectedPO.id : false"
								file-model="PurchaseOrderFile"
								record-foreign-key="po_id"
								:parent-store-location="resourceLocation"
								:parent-file-model="jobStoreKey == 'service' ? 'ServiceFile' : 'JobFile'"
								:readonly="isFinalized"
								:show-tag-filters="true"
								:file-tags="fileTags"
								v-on:filesChanged="fetchFiles(false)">
							</outbound-document-files-tab>
						</div>
						<div v-show="activeSection == 'Finalizing'">
							<div v-if="mutatedFiles.length > 0">
								<h3>Attachments</h3>

								<p>Choose the files you would like to send as part of the PO package:</p>

								<div v-for="(file,index) in mutatedFiles">
									<label>
										<input type="checkbox" v-model="selectedFiles" :value="file.id" v-on:change="saveAttachedFiles">

										{{ file.LibraryUpload.original_filename }} <span v-if="file.caption">({{file.caption}})</span>
										<span v-for="tag in file.tags" class="badge badge-primary mr-1">{{tag}}</span>
										<a :href="file.src" target="_blank">Download</a>
									</label>
								</div>
								<hr>
							</div>
							<h3>Finalizing</h3>

							<div class="d-flex flex-row justify-content-end align-items-center">
								<p style="margin-right: 10px;margin-bottom: 0">The PO must be finalized to move onto the delivery step</p>

								<div>
									<button class="btn btn-lg btn-success float-right" type="button" v-on:click="savePO(true)">
										<i class="fa fa-lock"></i>
										Finalize Purchase Order
									</button>
								</div>
							</div>

						</div>

						<div style="clear: both;margin-top: 10px;"></div>

						<button v-if="activeSection != 'Details'" class="btn btn-light float-left" v-on:click="prevStep">
							<i class="fa fa-chevron-left"></i> Previous Step
						</button>

						<button v-if="activeSection != 'Finalizing' && hasJobIdSet" class="btn btn-light float-right" v-on:click="nextStep">
							Next Step <i class="fa fa-chevron-right"></i>
						</button>

						<div style="clear: both;"></div>
						<comment-thread v-if="'slug' in selectedPO"
							:parent-slug="selectedPO.slug"
							parent-model="PurchaseOrder"
							:thread-id="'message_thread_id' in selectedPO ? selectedPO.message_thread_id : false"
							:thread-subject-reference="threadSubjectRef">
						</comment-thread>
					</vue-form>
				</div>
				<div v-if="activeSection == 'Delivery'" class="col-lg-6">

					<h3>Delivery & Download</h3>

					<p class="text-muted" v-if="selectedPO.last_emailed">Last emailed {{selectedPO.last_emailed == 'just now' ? 'just now' :  formatDateTimeToLocal(selectedPO.last_emailed)}}</p>

					<div class="mb-2 d-flex flex-row justify-content-between align-items-center">
						<field label="Status"
							col-class="col-3"
							v-model="selectedPO.status"
							:params="{type:statusChangerType,options:poStatusOptions}"
							v-on:change="statusAutosave"
							v-on:click="statusChangerType = 'select'">
						</field>

						<div>
							<button class="btn btn-light" v-on:click="deFinalize">
								<i class="fa fa-lock-open"></i>
								De-Finalize for Editing
							</button>
						</div>
					</div>

					<div class="d-flex flex-row flex-wrap mb-4">

						<a :href="poDLSrc" class="btn btn-light">
							<i class="fa fa-download"></i>
							Download PO
						</a>
						<a v-if="hasAttachedFiles" :href="poAttachmentSrc" class="btn btn-light">
							<i class="fa fa-paperclip"></i>
							Download Attached Files
						</a>

						<button class="btn btn-success ml-auto" v-on:click="openEmailModal">
							<i class="fa fa-download"></i>
							Email Purchase Order
						</button>

					</div>

					<modal-dialog
						:modal-visible="emailPOModal.visible"
						title="Send PO By Email"
						confirm-button-text="Send"
						:working="emailPOModal.working"
						v-on:confirm="emailPO"
						v-on:closeModal="emailPOModal.visible = false">

						<field label="PO Recipients"
							col-class="col-sm-6 col-md-4"
							:params="{type:'select-multi',options:poEmailRecipientOptions}"
							v-model="emailPOModal.recipients">
						</field>

						<field label="Internal Recipients"
							col-class="col-sm-6 col-md-4"
							:params="{type:'select-multi',options:usersWithRolesOptions}"
							v-model="emailPOModal.internalRecipients">
						</field>

						<additional-email-addresses-field v-model="emailPOModal.additionalRecipients">
						</additional-email-addresses-field>

					</modal-dialog>

					<accordion heading="Items Received">
						<table class="table table-sm">
							<thead>
								<tr>
									<th>Item</th>
									<th>Ordered</th>
									<th>Received</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in poItems">
									<td>{{ item.description }}</td>
									<td>{{ item.qty }}</td>
									<td>
										<field style="width: 80px;"
											:params="{type:'number',min:0}"
											v-model="poItems[index].qtyReceived">
										</field>
									</td>
								</tr>
							</tbody>
						</table>

						<button type="button"
							class="btn btn-light float-right"
							v-on:click="saveReceivedItems">
							Save
						</button>
						<div style="clear:both;"></div>
					</accordion>

					<comment-thread
						:parent-slug="selectedPO.slug"
						parent-model="PurchaseOrder"
						:thread-id="'message_thread_id' in selectedPO ? selectedPO.message_thread_id : false"
						:thread-subject-reference="threadSubjectRef">
					</comment-thread>
				</div>

				<div class="col-lg-6">
					<h3>PO Preview</h3>

					<pdf-js v-if="selectedPO.slug" :url="poPreviewSrc" :page="1"></pdf-js>
					<p v-else>Save the PO to generate a preview</p>
				</div>
			</div>

		</template>
	</collapsible-panel>

	<modal-dialog
		:modal-visible="bidMaterialSelectorModal.visible"
		:title="bidMaterialSelectorModal.title"
		confirm-button-text="Add to PO"
		:working="bidMaterialSelectorModal.working"
		v-on:closeModal="bidMaterialSelectorModal.visible = false"
		v-on:confirm="confirmAddMaterialsFromBid">

		<table class="table table-sm">
			<thead>
				<tr>
					<th></th>
					<th>Material</th>
					<!--
					<th>Category</th>
					<th>Qty Remaining</th>
					-->
					<th>Qty</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="material in bidMaterials">
					<td>
						<input type="checkbox" v-model="material.selected">
					</td>
					<td v-on:click="material.selected = !material.selected">
						<template v-if="material.description && material.description.length > 1">
							{{material.description}}
							<div v-if="material.part_number" style="line-height: 13px;"><small class="text-muted">{{material.part_number}}</small></div>
						</template>
						<template v-else>{{material.part_number}}</template>
					</td>
					<!--
					<td>{{material.categoryName}}</td>
					<td class="text-right">{{material.qtyRemaining}}</td>
					-->
					<td class="text-right">
						<field
							style="width: 100px;float: right;"
							:params="{type:'number',min:0,step:0.001,align:'right'}"
							v-model="material.qty">
						</field>
					</td>
				</tr>
			</tbody>
		</table>

		<button class="btn btn-light" v-on:click="addFromMaterialsDb" type="button">
			More Materials...
		</button>

	</modal-dialog>

	<material-selector-modal
		:visible="materialSelectorVisible"
		:disable-price="true"
		:job-id="resourceLocation == 'project' ? $store[resourceLocation].id : false"
		:service-id="resourceLocation == 'service' ? $store[resourceLocation].id : false"
		:disable-assemblies="true"
		v-on:closeModal="materialSelectorVisible = false"
		v-on:addMaterials="confirmAddMaterialsFromDb">
	</material-selector-modal>

	<modal-dialog
		:modal-visible="fileEditModal.visible"
		:title="fileEditModal.title"
		confirm-button-text="Save"
		:working="fileEditModal.working"
		v-on:closeModal="fileEditModal.visible = false"
		v-on:confirm="saveFileEdit">

		<upload-field v-if="!fileEditModal.filename"
			style="width:100%;height: 40px;margin-top:10px"
			:icons="['fa-plus','fa-file']"
			accept=".jpg,.jpeg,.png,.pdf,.heic"
			target="LibraryUpload/save"
			multiple="multiple"
			style-type="box"
			v-on:uploadStarted="fileEditModal.working = true"
			v-on:uploaded="fileUploaded($event,false)">
		</upload-field>

		<field v-else
			label="Filename"
			col-class="col-md-4"
			:readonly="true"
			v-model="fileEditModal.filename">
		</field>

		<field label="Caption"
			col-class="col-md-4"
			v-model="fileEditModal.payload.caption">
		</field>

		<field label="Tags"
			col-class="col-md-4"
			v-model="fileEditModal.tags"
			:params="{type:'select-multi',options: tagOptions}">
		</field>

	</modal-dialog>

	<modal-dialog
		:modal-visible="itemEditModal.visible"
		title="Add PO Item"
		:confirm-button-text="itemEditModal.confirmButtonText"
		v-on:closeModal="itemEditModal.visible = false"
		v-on:confirm="addNewItem">

		<field label="Description"
			col-class="col-md-4"
			v-model="itemEditModal.payload.description"
			:params="{type:'text',focus:true}"
			:readonly="!('isFreeForm' in itemEditModal.payload) || !itemEditModal.payload.isFreeForm">
		</field>
		<form-group label="Qty"
			col-class="col-md-4">

			<div class="d-flex flex-row">
				<field
					:params="{type:'number',step:1}"
					v-model="itemEditModal.payload.qty">
				</field>
				<field
					:params="{type:'select',options:$store.unitMeasurementOptions}"
					v-model="itemEditModal.payload.unit_type">
				</field>
			</div>

		</form-group>
		<field label="Unit Price"
			col-class="col-md-4"
			:params="{type:'number',step:0.01,min:0}"
			v-model="itemEditModal.payload.unit_price">
		</field>

	</modal-dialog>

	<modal-dialog
		:modal-visible="addFileFromProjectModal.visible"
		title="Add File from Project"
		cancel-button-text="Done"
		:submit-visible="false"
		v-on:closeModal="addFileFromProjectModal.visible = false">

		<div v-if="'JobFile' in $store.project && $store.project.JobFile" class="list-group">
			<label v-for="file in $store.project.JobFile" class="list-group-item">
				<input type="checkbox" class="mr-2" v-model="addFileFromProjectModal.selectedFiles" :value="file.id" v-on:change="fileFromProjectChange(file)">
				{{ file.caption }} <span class="text-muted">({{ file.UploadFile.original_filename }})</span>
			</label>
		</div>

		<div v-else-if="'ServiceFile' in $store.service && $store.service.ServiceFile" class="list-group">
			<label v-for="file in $store.service.ServiceFile" class="list-group-item">
				<input type="checkbox" class="mr-2" v-model="addFileFromProjectModal.selectedFiles" :value="file.id" v-on:change="fileFromProjectChange(file)">
				{{ file.caption }} <span class="text-muted">({{ file.UploadFile.original_filename }})</span>
			</label>
		</div>

	</modal-dialog>

	<modal-dialog
		:modal-visible="multipleAssociatedExpensesModal.visible"
		title="Associated Expenses"
		cancel-button-text="Done"
		modal-size="modal-full"
		:submit-visible="false"
		v-on:closeModal="multipleAssociatedExpensesModal.visible = false">

		<expense-table
			:filtering-tools="false"
			:hide-info-boxes="true"
			:skip-date-from-default="true"
			:filters="multipleAssociatedExpensesModal.filters">
		</expense-table>

	</modal-dialog>

	<expense-edit-modal v-if="associatedExpenseModal.record"
		:visible="associatedExpenseModal.visible"
		:record="associatedExpenseModal.record"
		:has-comments="true"
		:user-options-prop="userOptions()"
		:is-readonly="true"
		v-on:closeModal="associatedExpenseModal.visible = false">
	</expense-edit-modal>
</div>
</template>
<script type="text/javascript">

import ExpenseTable from "@/components/super_components/ExpenseTable"
import TableList from "@/components/TableList"
import PanelMenu from "@/components/PanelMenu"
import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"
import ModalDialog from "@/components/ModalDialog"
import FileListItem from "@/components/FileListItem"
import UploadField from "@/components/UploadField"
import ImagePanel from "@/components/ImagePanel"
import ImageThumbList from "@/components/ImageThumbList"
import CommentThread from "@/components/super_components/CommentThread"
import ExpenseEditModal from "@/components/super_components/ExpenseEditModal"
import Accordion from "@/components/Accordion"
import OutboundDocumentFilesTab from "@/components/super_components/OutboundDocumentFilesTab"
import AdditionalEmailAddressesField from "@/components/AdditionalEmailAddressesField"

import PdfJs from "@/components/PdfJs"

import JobMixins from "@/mixins/JobMixins.js"
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "PurchaseOrders",
	components: {
		TableList,
		PanelMenu,
		CollapsiblePanel,
		VueForm,
		Field,
		FormGroup,
		MaterialSelectorModal,
		ModalDialog,
		FileListItem,
		UploadField,
		ImagePanel,
		ImageThumbList,
		PdfJs,
		CommentThread,
		ExpenseEditModal,
		ExpenseTable,
		Accordion,
		OutboundDocumentFilesTab,
		AdditionalEmailAddressesField
	},
	mixins: [JobMixins,ProjectBidMixins],
	props: ["isServicePo","isMainList","mainListPath","selectedPoSlug"],
	data() {
		return {
			activeSection: null,
			selectedFiles: [],
			//selectedImages: [],
			statusChangerType: 'editable-static',
			poStatusOptions: [
				{text: 'Draft',value:'Draft'},
				{text: 'On Hold',value:'On Hold'},
				{text: 'Pending Approval',value:'Pending Approval'},
				{text: 'Issued',value:'Issued'},
				{text: 'Partially Received',value:'Partially Received'},
				{text: 'Partial Invoice Received',value: 'Partial Invoice Received'},
				{text: 'Full Invoice Received',value:'Full Invoice Received'},
				{text: 'Canceled',value:'Canceled'},,
				{text: 'Closed',value:'Closed'},
			],
			filterPanelVisible: false,
			filterValues: {
				service_id: null,
				job_id: null,
				dateFrom: null,
				dateTo: null
			},
			pos: [],
			pageNum: 1,
			numPages: 0,
			suppliers: [],
			supplierContacts: [],
			supplierLocations: [],
			showList: true,
			selectedPO: {
				issued_by_id: this.$store.userDetails.id
			},
			poItems: [],
			poFiles: [],
			freeFormItems: false,
			itemEditModal: {
				visible: false,
				payload: {},
				editIndex: false,
				confirmButtonText: "Add"
			},
			bidMaterials: [],
			bidMaterialSelectorModal: {
				visible: false,
				working: false,
				title: "Select Materials from Quote"
			},
			working: false,
			materialSelectorVisible: false,
			previewRefresher: 1,
			fileEditModal: {
				visible: false,
				working: false,
				title: "Add File",
				tags: [],
				filename: "",
				payload: {}
			},
			selectedFileTags: [],
			fileTags: [
				"Invoice",
				"Packing Slip",
				"Quote"
			],
			emailPOModal: {
				visible: false,
				additionalRecipients: [],
				recipients: [],
				internalRecipients: [],
				working: false
			},
			customAddresses: [],
			addFileFromProjectModal: {
				visible: false,
				selectedFiles: []
			},
			associatedExpenseModal: {
				visible: true,
				record: null
			},
			multipleAssociatedExpensesModal: {
				visible: false,
				filters: []
			},
			resourceLocation: null
		}
	},
	watch: {
		'$store.project'() {
			if ("id" in this.$store.project)
				this.fetchData()
		},
		'$store.service'() {
			if ("id" in this.$store.service)
				this.fetchData()
		},
		isMainList() {
			this.setResourceLocation()
		}
	},
	computed: {
		hasJobIdSet() {
			if (this.selectedPO && (("job_id" in this.selectedPO && this.selectedPO.job_id > 0) || ("service_id" in this.selectedPO && this.selectedPO.service_id > 0)))
				return true

			return false
		},
		fields() {
			let fields = [
				{label: "PO #",key:'fullPONum'},
				{label: "Supplier",key:'supplierName'},
				{label: "PO Date",key:'poDate'},
				{label: "Subject",key:'subject'},
				{label: "Files Added",key:"fileBadges"},
				{label: "Last Emailed",key:"lastEmailed"},
				{label: "Status",key:'status'}
			]

			if (this.isMainList) {
				fields.splice(1,0,{label: "Job",key:'jobTypeAndNum'})
			}

			return fields
		},
		threadSubjectRef() {
			if ("Job" in this.selectedPO && this.selectedPO.Job)
				return "Purchase Order: Project #"+this.selectedPO.Job.job_num
			else if ("Service" in this.selectedPO && this.selectedPO.service)
				return "Purchase Order: Service #"+this.selectedPO.Service.job_num
			else if (this.selectedPO && "subject" in this.selectedPO)
				return "Purchase Order: "+this.selectedPO.subject
			else
				return "Purchase Order"
		},
		isFinalized() {
			return "is_finalized" in this.selectedPO && this.selectedPO.is_finalized == 1
		},
		jobStoreKey() {
			if (this.isServicePo)
				return "service"
			else
				return "project"
		},
		menuItems() {
			let tabs = [
				"Details"
			]

			if (this.hasJobIdSet) {

				tabs = [
					...tabs,
					"Order Items",
					"Files",
				]

				if ("is_finalized" in this.selectedPO && this.selectedPO.is_finalized == 1)
					tabs.push("Delivery")
				else
					tabs.push("Finalizing")
			}

			return tabs
		},
		backUrl() {
			if (this.isMainList)
				return this.mainListPath
			else
				return '/'+this.resourceLocation+'/'+this.$store[this.resourceLocation].slug+'/purchase-orders'
		},
		addressOptions() {

			let addresses = []
			try {
				 addresses = JSON.parse(JSON.stringify(this.customAddresses))
			}
			catch (ex) {}

			addresses.unshift({
				id: "head",
				place_name: "Head Office",
				address: this.$store.company.address,
				city: this.$store.company.city,
				province: this.$store.company.province,
				country: this.$store.company.country,
				postal_code: this.$store.company.postal_code
			})

			if (this.resourceLocation) {
				addresses.unshift({
					id: "project",
					place_name: "Job Site",
					address: this.$store[this.resourceLocation].address,
					city: this.$store[this.resourceLocation].city,
					province: this.$store[this.resourceLocation].province,
					country: this.$store[this.resourceLocation].country,
					postal_code: this.$store[this.resourceLocation].postal_code
				})
			}

			addresses.unshift({
				id: "pickup",
				place_name: "Pick up",
				address: "",
				city: "",
				province: "",
				country: "",
				postal_code: ""
			})

			return addresses.map(addr => {
				let text = addr.place_name

				if (addr.address)
					text += " ("+addr.address+", "+addr.city+")"

				return {
					value: JSON.stringify(addr),
					text: text
				}
			})
		},
		poPreviewSrc() {
			return window.apiBase+"PurchaseOrder/pdf?slug="+this.selectedPO.slug+"&token="+this.$store.sessionToken+"&humanReadable=true"+"&v="+this.previewRefresher
		},
		poDLSrc() {
			return window.apiBase+"PurchaseOrder/pdf?slug="+this.selectedPO.slug+"&token="+this.$store.sessionToken+"&humanReadable=true&download=true"
		},
		poAttachmentSrc() {
			return window.apiBase+"PurchaseOrder/get-attached-files?slug="+this.selectedPO.slug+"&token="+this.$store.sessionToken+"&type=zip"
		},
		hasAttachedFiles() {
			if (this.selectedFiles.length > 0)
				return true
			else
				return false
		},
		tagOptions() {
			let vm = this

			return this.optionify(this.fileTags.map(tag => {
				return {id:tag,value:tag}
			}),"value")
		},
		mutatedPOItems() {
			let vm = this

			return this.poItems.filter(item => !!item).map(item => {
				if (item && "isFreeForm" in item && item.isFreeForm)
					item.richDescription = item.description

				else {
					let mainLabel = ""
					if ("part_number" in item && item.part_number)
							mainLabel = item.part_number+" "
					else
						mainLabel = item.description

					let smallLabel = ""
					if (mainLabel)
						smallLabel = '<small class="text-muted">'+item.description+'</small>'

					let catLabel = ""
					if (item.categoryName)
						catLabel = '<div style="line-height: 13px;"><small class="text-muted">(from '+item.categoryName+')</small></div>'

					item.richDescription = mainLabel+smallLabel+catLabel

					if ("material_unit_type" in item && item.material_unit_type)
						item.unit_type = item.material_unit_type
				}

				let unitPrice = 0
				if ("unit_price" in item && +item.unit_price != 0)
					unitPrice = +item.unit_price
				else if ("material_price" in item) {
					let per = 1
					if ("per" in item && item.per)
						per = item.per

					unitPrice = +item.material_price / per
				}

				item.unitPriceFormatted = unitPrice.toFixed(3)

				return item
			})
		},
		mutatedPOs() {
			let vm = this

			return this.pos.map(po => {

				po.fullPONum = ""
				po.jobTypeAndNum = ""
				if ("Job" in po && po.Job) {
					po.fullPONum = po.Job.job_num+"-"+po.po_num
					po.jobTypeAndNum = "Project #" + po.Job.job_num
				}
				else if ("Service" in po && po.Service) {
					po.fullPONum = po.Service.job_num+"-"+po.po_num
					po.jobTypeAndNum = "Service #" + po.Service.job_num
				}

				po.supplierName = ""
				if ("Supplier" in po && po.Supplier)
					po.supplierName = po.Supplier.name

				po.poDate = vm.formatDate(po.po_date)
				po.lastEmailed = vm.formatDateTimeToLocal(po.last_emailed)

				po.fileBadges = "<span class='badge badge-primary'>Packing Slip</span> <span class='badge badge-secondary'>Invoice</span> <span class='badge badge-info'>Quote</span>"

				let fileBadges = []
				if ("PurchaseOrderFile" in po && po.PurchaseOrderFile) {

					po.PurchaseOrderFile.forEach(file => {
						let tags = []
						try {
							tags = JSON.parse(file.tags_json)
						}
						catch (e) {}

						tags.forEach(tag => {
							if (tag && fileBadges.indexOf(tag) >= -1)
								fileBadges.push(tag)
						})
					})
				}

				let badgeClassesMap = {
					'Quote': "badge-secondary",
					"Packing Slip": "badge-primary",
					"Invoice": "badge-info"
				}

				po.fileBadges = ""
				fileBadges.forEach(badge => {
					po.fileBadges += "<span class='badge "+badgeClassesMap[badge]+"'>"+badge+"</span>"
				})

				po.hasSingleExpense = false
				po.hasMultipleExpenses = false
				if ("Expense" in po && po.Expense) {
					if (po.Expense.length == 1)
						po.hasSingleExpense = true
					else if (po.Expense.length > 1)
						po.hasMultipleExpenses = true
				}

				return po
			})
		},
		supplierOptions() {
			let vm = this

			return this.optionify(this.suppliers,"name")
		},
		supplierContactOptions() {
			return this.optionify(this.supplierContacts,"name")
		},
		supplierLocationOptions() {
			let main = [{ text: "Main", value: null }]
			return main.concat(this.optionify(this.supplierLocations, "location_name"))
		},
		poEmailRecipientOptions() {
			let supplierContact = this.suppliers.find(contact => contact.id == this.selectedPO.supplier_id)

			let contacts = []

			if (supplierContact)
				contacts.push(supplierContact)

			contacts = contacts.concat(this.supplierContacts)

			return this.optionify(contacts.filter(contact => contact.email != "").map(contact => {
				contact.display = contact.name + " (" + contact.email + ")"

				return contact
			}),"display")
		},
		usersWithRolesOptions() {
			let vm = this

			if (!this.resourceLocation)
				return []

			let users = this.$store.users.map(user => {
				//find roles on project
				let roles = []
				if ("JobPersonnelRole" in vm.$store[vm.resourceLocation] && vm.$store[vm.resourceLocation].JobPersonnelRole) {
					roles = vm.$store[vm.resourceLocation].JobPersonnelRole.filter(role => role.user_id == user.id).map(role => role.title)
				}
				user.roles = roles.join(", ")

				user.optionDisplay = user.first_name+" "+user.last_name
				if (user.roles)
					user.optionDisplay += " ("+user.roles+")"

				return user
			}).sort((a,b) => {
				if (b.roles)
					return 1
				else if (a.roles)
					return -1
				else {
					if (a > b)
						return -1
					else
						return 1
				}
			})

			return this.optionify(users,"optionDisplay")
		},

		mutatedFiles() {
			let vm = this

			return this.poFiles.map(file => {

				file.fileId = file.LibraryUpload.file_id
				file.filename = file.LibraryUpload.original_filename
				file.sizeKb = file.LibraryUpload.file_size_kb
				file.src = window.apiRoot+"resources/files/"+vm.$store.sessionToken+"/"+file.LibraryUpload.filename
				file.thumbUrl = window.apiRoot+"resources/files/"+vm.$store.sessionToken+"/"+file.LibraryUpload.thumb_filename

				file.tags = []

				//for image-thumb-list
				file.fullUrl = file.src

				let segs = file.filename.split("?")[0].split(".")
				let ext = segs[segs.length-1]

				if (ext.toLowerCase() == 'pdf') {
					file.fullUrl += "?display=true"
					file.thumbUrl = window.apiRoot+"resources/files/"+vm.$store.sessionToken+"/"+file.LibraryUpload.filename+"?display=true"
				}

				try {
					file.tags = JSON.parse(file.tags_json)
				}
				catch (e) {}

				return file
			}).filter(file => {

				//if no file tags selected, show all
				if (vm.selectedFileTags.length == 0)
					return true

				let found = false

				file.tags.forEach(tag => {
					if (vm.selectedFileTags.indexOf(tag) >= 0)
						found = true
				})

				return found

				return false
			})
		}
	},
	methods: {
		prevStep() {
			//find index of current and minus one
			this.activateSection(this.menuItems[this.menuItems.indexOf(this.activeSection)-1])
		},
		nextStep() {
			//find index of current and minus one
			this.activateSection(this.menuItems[this.menuItems.indexOf(this.activeSection)+1])
		},
		updateItemOrder(event) {
			//remove from old index
			let movedItem = this.poItems.splice(event.oldIndex,1)

			//insert into new place
			this.poItems.splice(event.newIndex,0,movedItem[0])

			//this.poItems = this.poItems.splice(event.newIndex,0,this.poItems.splice(event.oldIndex,1)[0])
		},
		setPOItems() {
			let poItems = []
			try {
				poItems = JSON.parse(this.selectedPO.line_items_json)
			}
			catch (e) {}

			this.poItems = poItems
		},
		setResourceLocation() {
			if (!this.isMainList) {
				if (this.isServicePo)
					this.resourceLocation = "service"
				else
					this.resourceLocation = "project"
			}
			else
				this.resourceLocation = false
		},
		setSelectedFiles() {
			let selectedFiles = []

			try {
				selectedFiles = JSON.parse(this.selectedPO.attached_files_json)
			}
			catch (e) {}

			this.selectedFiles = selectedFiles
		},
		openFilterPanel() {
			this.filterPanelVisible = true

			this.fetchOptions()
		},
		jobSelected(id,resource) {
			let vm = this
			this.getJSON(resource + "/find/" + id).then(response => {
				if (response.success) {
					vm.resourceLocation = resource == 'Job' ? 'project' : 'service'
					vm.$store[vm.resourceLocation] = response.data
					
					if (resource == 'Job')
						vm.fetchBidMaterials()
					else
						vm.fetchQuoteMaterials()
				}
			})
		},
		newPO() {
			if (this.isMainList) {
				window.history.pushState({},"",this.mainListPath + "/new")

				if (this.$store.services.length == 0)
					this.fetchServices([{model:"Contact",fields:["name"]}],false,["job_name","job_num","customer_id","Customer"])
				if (this.$store.projects.length == 0)
					this.fetchJobs([],false,["job_name","job_num"])
			}
			else
				window.history.pushState({},"","/"+this.resourceLocation+"/"+this.$route.params.id+"/purchase-orders/new")

			this.poItems = []
			this.showList = false
			this.activeSection = "Details"

			this.selectedPO = {}
			this.selectedPO.terms = this.$store.company.CompanySetting.po_terms
			this.selectedPO.instructions = this.$store.company.CompanySetting.po_instructions

			if (this.isMainList) {

			}
			else {
				if (this.isServicePo)
					this.selectedPO.service_id = this.$store.service.id
				else
					this.selectedPO.job_id = this.$store.project.id
			}
		},
		viewAssociatedExpense(po) {
			let vm = this
			this.fetchAssociatedExpense(po.Expense[0].slug).then(response => {
				if (response.success) {
					vm.associatedExpenseModal.record = response.data
					vm.associatedExpenseModal.record.PurchaseOrder = po //manually attach PO relation
					vm.associatedExpenseModal.visible = true
				}
			})
			this.fetchUsers([],false,["first_name","last_name","email"])
		},
		viewAssociatedExpenses(po) {
			let vm = this
			console.log(po)
			this.multipleAssociatedExpensesModal.filters = [
				["purchase_order_id",po.id]
			]
			this.multipleAssociatedExpensesModal.visible = true
		},
		editPO(po) {
			this.selectedPO = po

			let vm = this

			vm.fetchSupplierContacts().then(response => {
				let supplier_contact_id = po.supplier_contact_id
				vm.selectedPO.supplier_contact_id = null

				vm.$nextTick(() => {

					vm.selectedPO.supplier_contact_id = supplier_contact_id

				})
			})
			vm.fetchSupplierLocations()
			
			this.showList = false

			if (po.is_finalized == 0)
				this.activeSection = "Details"
			else
				this.activeSection = "Delivery"

			this.setPOItems()
			this.setSelectedFiles()

			let jobType = ""
			let jobSlug = ""

			if (this.isMainList) {
				if ("Job" in po && po.Job) {
					jobType = "/project/"
					jobSlug = po.Job.slug
				}
				else if ("Service" in po && po.Service) {
					jobType = "/service/"
					jobSlug = po.Service.slug
				}

				if (this.$store.services.length == 0)
					this.fetchServices([{model:"Contact",fields:["name"]}],false,["job_name","job_num","customer_id","Customer"])
				if (this.$store.projects.length == 0)
					this.fetchJobs([],false,["job_name","job_num"])
			}
			else {
				jobSlug = this.$route.params.id
				jobType = "/project/"
				if (vm.isServicePo)
					jobType = "/service/"
			}

			if (this.isMainList)
				window.history.pushState({},"",this.mainListPath + "/" + this.selectedPO.slug)
			else
				window.history.pushState({},"",jobType+jobSlug+"/purchase-orders/"+this.selectedPO.slug)

			this.fetchFiles(false)
		},
		addFileFromProject() {
			this.addFileFromProjectModal.visible = true
		},
		fileFromProjectChange(value) {
			let vm = this

			let payload = {}

			if (this.addFileFromProjectModal.selectedFiles.indexOf(value.id) >= 0) {
				//add file
				payload = {
					file_id: value.UploadFile.id,
					caption: value.caption,
					po_id: this.selectedPO.id
				}

				this.postData("PurchaseOrderFile/save",payload,true).then(response => {
					if (response.success) {
						vm.fetchFiles()
					}
				})
			}
			else {
				//find id
				let fileFromPO = this.poFiles.find(poFile => poFile.file_id == value.UploadFile.id)

				if (fileFromPO) {

					payload = {
						id: fileFromPO.id,
						keepFile: true
					}

					this.postData("PurchaseOrderFile/delete",payload,true).then(response => {
						if (response.success) {
							vm.fetchFiles()
						}
					})
				}
			}
		},
		confirmAddFilesFromProject() {

		},
		addFile() {
			this.fileEditModal.visible = true
			this.fileEditModal.title = "Add File"
			this.fileEditModal.filename = ""
			this.fileEditModal.payload = {
				id: "",
				caption: "",
			}

			this.fileEditModal.tags = []
			
		},
		editFile(file) {
			this.fileEditModal.visible = true
			this.fileEditModal.title = "Edit File"
			this.fileEditModal.filename = file.filename
			this.fileEditModal.payload = {
				id: file.id,
				caption: file.caption,
			}

			try {
				this.fileEditModal.tags = JSON.parse(file.tags_json)
			}
			catch (e) {
				this.fileEditModal.tags = []
			}
		},
		saveFileEdit() {
			let vm = this

			this.fileEditModal.payload.tags_json = JSON.stringify(this.fileEditModal.tags)

			this.fileEditModal.working = true
			this.postData("PurchaseOrderFile/save",this.fileEditModal.payload,true).then(response => {

				vm.fileEditModal.working = false

				if (response.success) {
					vm.fetchFiles()
					vm.alertSaved("File saved")
					vm.fileEditModal.visible = false
				}
			})
		},
		deFinalize() {
			let vm = this

			let payload = {
				id: this.selectedPO.id,
				is_finalized: 0
			}

			this.postData("PurchaseOrder/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("PO De-finalized")

					vm.selectedPO.is_finalized = 0

					if (vm.activeSection == 'Delivery')
						vm.activeSection = "Finalizing"
				}
			})
		},
		statusAutosave(value) {
			let vm = this

			let payload = {
				id: this.selectedPO.id,
				status: value
			}

			this.postData("PurchaseOrder/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("PO status changed")
					vm.statusChangerType = 'editable-static'
				}
				
			})
		},
		richTextChange() {
			if ("id" in this.selectedPO)
				this.debounce('savePO',false,10000)
		},
		savePO(finalize) {
			let vm = this

			let fieldsToUse = [
				"id",
				"supplier_id",
				"job_id",
				"service_id",
				"subject",
				"po_date",
				"terms",
				"instructions",
				"supplier_contact_id",
				"supplier_location_id",
				"site_contact_id",
				'issued_by_id',
				"status",
				"ship_to_address_json"
			]

			let payload = {}

			fieldsToUse.forEach(field => {
				if (field in vm.selectedPO)
					payload[field] = vm.selectedPO[field]
			})

			if (this.isMainList) {

			}
			else {
				if (this.isServicePo)
					payload.service_id = this.$store.service.id
				else
					payload.job_id = this.$store.project.id
			}

			payload.line_items_json = JSON.stringify(vm.poItems)

			if (finalize)
				payload.is_finalized = 1

			this.working = true

			this.postData("PurchaseOrder/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("PO saved")

					if (finalize) {
						vm.selectedPO.is_finalized = 1
						if (vm.activeSection == 'Finalizing')
							vm.activeSection = "Delivery"
					}

					if (!("id" in payload)) {
						window.history.pushState({},"","/"+vm.resourceLocation+"/"+vm.$route.params.id+"/purchase-orders/"+response.data.slug)
						vm.selectedPO.id = response.data.record_id
						vm.selectedPO.slug = response.data.slug
					}
				}

				vm.previewRefresher++

				vm.working = false
			})

		},
		fileUploaded(response,savePORecord) {
			//create the record link to the service

			let vm = this

			vm.fileEditModal.filename = response.data.original_filename
			vm.fileEditModal.working = false

			vm.fileEditModal.payload.file_id = response.data.id
			vm.fileEditModal.payload.po_id = this.selectedPO.id

			delete vm.fileEditModal.payload.id

			if (savePORecord) {

				let payload = {
					po_id: this.selectedPO.id,
					file_id: response.data.id
				}

				this.postData("PurchaseOrderFile/save",payload,true).then(response => {
					if (response.success) {
						vm.alertSaved("File uploaded")

						vm.fetchFiles()
					}
				})
			}
		},
		saveAttachedFiles() {
			let payload = {
				id: this.selectedPO.id,
				attached_files_json: JSON.stringify(this.selectedFiles)
			}

			this.postData("PurchaseOrder/save",payload,false)
		},
		backToList() {
			let location = "project"
			if (this.isServicePo)
				location = "service"

			this.fetchPOs(true)

			if (this.isMainList)
				window.history.pushState({},"",this.mainListPath)
			else
				window.history.pushState({},"","/"+this.resourceLocation+"/"+this.$route.params.id+"/purchase-orders")
			
			this.showList = true
		},
		activateSection(item) {
			this.activeSection = item

			if (this.activeSection == 'Order Items' && this.bidMaterials.length == 0) {
				if (this.isServicePo) 
					this.fetchQuoteMaterials()
				else
					this.fetchBidMaterials()
			}
		},
		addFreeformItem() {
			this.itemEditModal = {
				visible: true,
				editIndex: false,
				payload: {
					isFreeForm: true,
					description: "",
					qty: 1,
					unit_price: 0
				},
				confirmButtonText: "Add"
			}

			if (this.$store.unitMeasurementOptions.length == 0)
				this.fetchMeasurementUnits()
		},
		editItem(item) {
			let index = this.poItems.findIndex(poItem => poItem.description == item.description && poItem.qty == item.qty && poItem.unit_price == item.unit_price)

			if (this.$store.unitMeasurementOptions.length == 0)
				this.fetchMeasurementUnits()

			if (index >= 0) {
				this.itemEditModal.visible = true
				this.itemEditModal.editIndex = index
				this.itemEditModal.payload = JSON.parse(JSON.stringify(item))
				this.itemEditModal.confirmButtonText = "Confirm"

				if (!("isFreeForm" in item) || !item.isFreeForm) 
					this.itemEditModal.payload.unit_price = +item.material_price / +item.per
			}
		},
		addNewItem() {
 			if ("editIndex" in this.itemEditModal && this.itemEditModal.editIndex !== false) 
 				this.poItems.splice(this.itemEditModal.editIndex,1,JSON.parse(JSON.stringify(this.itemEditModal.payload)))
 			else
				this.poItems.push(JSON.parse(JSON.stringify(this.itemEditModal.payload)))

			if (this.$store.unitMeasurementOptions.length == 0)
				this.fetchMeasurementUnits()

			this.itemEditModal.payload.description = ""
			this.itemEditModal.payload.qty = 1
			this.itemEditModal.payload.unit_price = 0

			this.itemEditModal.visible = false
		},
		removeItem(item,index) {
			this.poItems.splice(index,1)
		},
		saveReceivedItems() {
			let vm = this

			let payload = {
				id: this.selectedPO.id,
				line_items_json: JSON.stringify(vm.poItems)
			}

			this.working = true

			this.postData("PurchaseOrder/save",payload,true).then(response => {
				if (response.success) 
					vm.alertSaved("Received items saved")

				vm.working = false
			})
		},
		addMaterialsFromEstimate() {
			let vm = this

			this.bidMaterialSelectorModal.visible = true

			if (this.selectedPO && "service_id" in this.selectedPO && this.selectedPO.service_id > 0)
				this.bidMaterialSelectorModal.title = "Select Materials from Quote"
			else
				this.bidMaterialSelectorModal.title = "Select Materials from Bid"

			this.bidMaterials.forEach(estMat => {
				let poItem = vm.poItems.find(poItem => "material_id" in poItem && poItem.material_id == estMat.id)

				if (poItem)
					estMat.qty = poItem.qty

			})
		},
		confirmAddMaterialsFromBid() { 
			let vm = this

			let selectedMaterials = this.bidMaterials.filter(mat => mat.qty > 0 && mat.selected).map(mat => {

				let matPrice = 0
				let unit_price = 0

				if ("material_price" in mat)
					matPrice = +mat.material_price
				else if ("materialPrice" in mat)
					matPrice = +mat.materialPrice
				else if ("price" in mat)
					matPrice = +mat.price

				unit_price = matPrice / +mat.per
				if (isNaN(unit_price))
					unit_price = 0

				let materialUnitType = ""
				if ("material_unit_type" in mat && mat.material_unit_type)
					materialUnitType = mat.material_unit_type
				else if ("parsedFields" in mat && mat.parsedFields && "material_unit_type" in mat.parsedFields && mat.parsedFields.material_unit_type)
					materialUnitType = mat.parsedFields.material_unit_type

				return {
					part_number: mat.part_number,
					supplier_number: mat.supplier_number,
					description: mat.description,
					categoryName: mat.categoryTrail,
					qty: +mat.qty,
					isFreeForm: false,
					material_id: mat.id,
					per: mat.per,
					material_price: matPrice,
					unit_price: unit_price,
					material_unit_type: materialUnitType
				}
			})

			//make sure duplicate materials don't get added to a new line
			selectedMaterials.forEach(selMat => {
				let poItem = vm.poItems.find(poItem => (
						"part_number" in selMat && selMat.part_number && 
						selMat.part_number.trim() && 
						"part_number" in poItem && poItem.part_number &&
						poItem.part_number.trim() == selMat.part_number.trim()
					) || 
					selMat.description == poItem.description)

				if (poItem) {
					//update qty
					poItem.qty = +selMat.qty
				}
				else
					this.poItems.push(selMat)
			})

			this.bidMaterialSelectorModal.visible = false

			this.savePO()
		},
		addFromMaterialsDb() {
			this.materialSelectorVisible = true
		},
		confirmAddMaterialsFromDb(payload) {

			let vm = this

			let selectedMaterials = payload.map(mat => {
				if (typeof mat.per == 'undefined')
					mat.per = 1

				return {
					part_number: mat.part_number,
					supplier_number: mat.supplier_number,
					description: mat.description,
					categoryName: mat.categoryName,
					material_unit_type: mat.material_unit_type,
					qty: mat.qty,
					isFreeForm: false,
					material_id: mat.id,
					per: mat.per,
					material_price: mat.price,
					unit_price: +mat.price / +mat.per
				}
			})

			this.bidMaterials.forEach(mat => {
				mat.qty = ""
			})

			//make sure duplicate line items aren't added (combine quantities)
			selectedMaterials.forEach(selMat => {
				let poItem = vm.poItems.find(poItem => poItem.material_id == selMat.material_id)

				if (poItem) {
					//add to qty
					poItem.qty = +poItem.qty + +selMat.qty
				}
				else
					vm.poItems.push(selMat)
			})

			this.materialSelectorVisible = false
			this.bidMaterialSelectorModal.visible = false
		},
		deleteFile(file) {
			let vm = this

			let payload = {
				id: file.id
			}

			//if file is from files tab, we do not want to delete source file, just the purchase order file record
			if ("JobFile" in this.$store[this.jobStoreKey] && this.$store[this.jobStoreKey].JobFile && this.$store[this.jobStoreKey].JobFile.find(jobFile => jobFile.UploadFile.id == file.file_id))
				//file not found, we can delete
				payload.keepFile = true

			let promises = [
				this.postData("PurchaseOrderFile/delete",payload)
			]

			Promise.all(promises).then(responses => {
				if (responses[0].success) {
					vm.alertSuccess("File deleted")
					vm.fetchFiles()
				}
			})
		},
		openEmailModal() {
			this.emailPOModal.additionalRecipients = []
			this.emailPOModal.visible = true

			if (this.emailPOModal.recipients.length == 0 && this.selectedPO.supplier_contact_id) {
				//prefill with supplier contact
				this.emailPOModal.recipients = [this.selectedPO.supplier_contact_id] 
			}
		},
		emailPO() {
			let vm = this

			this.emailPOModal.working = true

			let payload = {
				po_id: this.selectedPO.id,
				additional: this.emailPOModal.additionalRecipients.join(","),
				internal_recipients: this.emailPOModal.internalRecipients,
				recipients: this.emailPOModal.recipients
			}

			this.postData("PurchaseOrder/send",payload).then(response => {
				vm.emailPOModal.working = false

				if (response.success) {
					vm.alertSuccess("Purchase Order Sent!")
					vm.emailPOModal.visible = false
					vm.selectedPO.last_emailed = "just now"
				}
			})
		},
		supplierChange() {
			let vm = this

			vm.selectedPO.supplier_contact_id = null
			vm.selectedPO.supplier_location_id = null

			this.$nextTick(() => {
				vm.fetchSupplierContacts()
				vm.fetchSupplierLocations()
			})
		},
		loadMore() {
			this.pageNum++

			this.fetchPOs(true)
		},
		fetchFiles(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {

				let params = {
					include: ["LibraryUpload"],
					filters: [
						["po_id",vm.selectedPO.id]
					]
				}

				vm.getJSON("PurchaseOrderFile/get",params).then(response => {
					if (spinner)
						vm.spinner(false)

					if (response.success) {
						vm.poFiles = response.data

						//JobFile.is what is bound to the checkboxes
						if ("JobFile" in this.$store[this.jobStoreKey] && this.$store[this.jobStoreKey].JobFile) {
							vm.addFileFromProjectModal.selectedFiles = this.$store[this.jobStoreKey].JobFile.filter(jobFile => {
								if (vm.poFiles.find(poFile => poFile.file_id == jobFile.UploadFile.id))
									return true
							}).map(jobFile => jobFile.id)
						}
						else
							vm.addFileFromProjectModal.selectedFiles = []
					}

					resolve(response)
				})

			})
		},
		filtersChanged() {
			let vm = this
			this.$nextTick(() => {
				vm.fetchPOs(true)
			})
		},
		fetchPO(slug) {
			let vm = this

			let params = {
				include: [
					{model: "Job",fields: ["id","slug","job_num","job_name"]},
					{model: "Service",fields: ["id","slug","job_num","job_name"]},
					{model: "Contact", fields: ["id","slug","name"]},
					{model: "Expense",fields: ["id","slug"]},
					"PurchaseOrderFile"
				]
			}

			return new Promise((resolve, reject) => {
				vm.getJSON("PurchaseOrder/find/" + slug,params).then(response => {
					resolve(response)
				})
			})
		},
		fetchPOs(spinner) {
			let vm = this

			let field = "job_id"
			if (this.isServicePo)
				field = "service_id"

			let filters = []

			let params = {
				include: [
					{model: "Job",fields: ["id","slug","job_num","job_name"]},
					{model: "Service",fields: ["id","slug","job_num","job_name"]},
					{model: "Contact", fields: ["id","slug","name"]},
					{model: "Expense",fields: ["id","slug"]},
					"PurchaseOrderFile"
				],
				orders: [
					["po_num","DESC"]
				],
				page: this.pageNum
			}

			if (!this.isMainList) {
				filters = [
					[field,this.$store[vm.resourceLocation].id]
				]
			}

			if (this.filterValues.job_id > 0)
				filters.push(["job_id",this.filterValues.job_id])

			if (this.filterValues.service_id > 0)
				filters.push(["service_id",this.filterValues.service_id])

			if (this.filterValues.dateFrom) 
				filters.push(["po_date >=", this.filterValues.dateFrom])
			
			if (this.filterValues.dateTo)
				filters.push(["po_date <=", this.filterValues.dateTo])

			if (filters.length > 0)
				params.filters = filters

			if (spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {

				vm.getJSON("PurchaseOrder/get",params,true).then(response => {
					if (response.success) {
						if (vm.pageNum == 1)
							vm.pos = response.data
						else {
							vm.pos = [
								...vm.pos,
								...response.data
							]
						}

						if ("meta" in response && response.meta && "num_pages" in response.meta)
							vm.numPages = response.meta.num_pages
					}

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})

			})
		},
		fetchSupplierContacts() {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					filters: [
						["is_company",0],
						["contact_id",vm.selectedPO.supplier_id]
					],
					fields: ["id","slug","name","email"]
				}

				vm.getJSON("Contact/get",params).then(response => {
					vm.supplierContacts = response.data

					resolve(response)
				})

			})
			
		},
		fetchSupplierLocations() {
			let vm = this
			if (!vm.selectedPO || !("supplier_id" in vm.selectedPO) || !vm.selectedPO.supplier_id) {
				vm.supplierLocations = []
				return Promise.resolve()
			}
			return new Promise((resolve, reject) => {
				let params = {
					filters: [["contact_id", vm.selectedPO.supplier_id]],
					fields: ["id", "slug", "location_name", "address", "suite", "city", "province", "postal_code"]
				}
				vm.getJSON("ContactLocation/get", params).then(response => {
					vm.supplierLocations = response.data || []
					resolve(response)
				})
			})
		},
		fetchBidMaterials() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.fetchActiveBid({projectId: vm.$store.project.id}).then(bid => {
					if (bid) {
						vm.fetchAllComponents(bid.id).then(response => {

							let suggestedMaterials = vm.flattenedRecordsFromNested("materials")

							vm.bidMaterials = suggestedMaterials.map(mat => {
								mat.categoryName = ""

								if ("sourceRecords" in mat && mat.sourceRecords && mat.sourceRecords.length > 0) {
									if ("parsedFields" in mat.sourceRecords[0] && mat.sourceRecords[0].parsedFields) {
										if ("categoryName" in mat.sourceRecords[0].parsedFields)
											mat.categoryName = mat.sourceRecords[0].parsedFields.categoryName
									}
								}

								return mat

							})

							resolve(response)
						})
					}
					else
						resolve(false)
				})
			})

			/*

			let params = {
				filters: [
					["job_id",this.$store.project.id],
					["is_active",1]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("JobBid/get",params).then(response => {
					if (response.success && response.data.length > 0) {

						let bid = response.data[0]

						params = {
							filters: [
								["bid_id",bid.id]
							],
							include: [
								{
									model: "JobBidComponentObject",
									filters: [
										["type","Material"]
									]
								}
							]
						}

						vm.getJSON("JobBidComponent/get",params).then(response => {
							if (response.success) {
								let materials = []

								response.data.forEach(component => {

									if ("JobBidComponentObject" in component && component.JobBidComponentObject) {
										component.JobBidComponentObject.forEach(obj => {

											try {	
												let matObj = JSON.parse(obj.field_values_json)

												let foundIndex = materials.findIndex(mat => mat.material_id == matObj.material_id)

												if (foundIndex == -1) {
													let qty = +matObj.qty
													matObj.qty = qty.round(3)

													materials.push(matObj)
												}
												else {
													let qty = +matObj.qty
													qty = qty.round(3)

													materials[foundIndex].qty += qty
												}
											}
											catch (e) {}


										})
									}
								})

								vm.bidMaterials = materials
							}
						})

					}

					resolve(response)
				})

			})

			*/

		},
		fetchOptions() {
			if (this.isMainList) {
				if (this.$store.projects.length == 0)
					this.fetchJobs([],false,["job_name","job_num"])
				if (this.$store.services.length == 0)
					this.fetchServices([],false,["job_name","job_num"])
			}
		},
		fetchAssociatedExpense(slug) {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON("Expense/find/"+slug,{include: ["User","ReceiptImage","Service","Job"]}).then(response => {
					resolve(response)
				})

			})
		},
		fetchQuoteMaterials() {
			let vm = this

			return new Promise((resolve,reject) => {

				let quoteParams = {
					filters: [
						["is_quote",1],
						["service_id",vm.$store[vm.resourceLocation].id]
					],
					fields: ["id","slug"],
					include: [{model:"ServiceInvoiceObject",filters:[["type","Material"]]}]
				}

				vm.getJSON("ServiceInvoice/get",quoteParams).then(response => {
					if (response.success) {
						let materials = []
						if ("ServiceInvoiceObject" in response.data[0] && response.data[0].ServiceInvoiceObject) {
							response.data[0].ServiceInvoiceObject.forEach(obj => {
								try {
									let matObj = JSON.parse(obj.field_values_json)

									materials.push(matObj)
								}
								catch (e) {}
							})
						}

						vm.bidMaterials = materials
					}

					resolve(response)
				})

			})
		},
		fetchData(skipPOList) {
			let vm = this

			let contactParams = {
				filters: [
					["is_supplier",1],
				],
				fields: ["id","slug","name","email"]
			}

			/*
			let bidMaterialsParams = {
				filters: [
					["job_id",this.$store.project.id]
				]
			}
			*/

			let promises = [
				this.getJSON("Contact/get",contactParams),
				this.fetchUsers([],false,["id","first_name","last_name"]),
				this.getJSON("CompanyAddress/get")
			]

			if (!skipPOList)
				promises.push(this.fetchPOs(false))

			if (this.isMainList) {
				if (!vm.isServicePo)
					promises.push(this.fetchBidMaterials())
				else 
					promises.push(this.fetchQuoteMaterials())		
			}

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success) 
					vm.suppliers = responses[0].data

				if (responses[2].success) 
					vm.customAddresses = responses[2].data
			})
		}
	},
	created() {
		let vm = this
		this.setResourceLocation()
		if ((this.isMainList || (this.resourceLocation && "id" in this.$store[this.resourceLocation]))) {

			this.fetchData()
		}

		if (this.selectedPoSlug) {

			console.log(this.selectedPoSlug)

			if (this.selectedPoSlug == 'new')
				this.newPO()
			else {
				this.fetchPO(this.selectedPoSlug).then(response => {
					vm.editPO(response.data)
				})
			}
		}

		if (this.isMainList) {
			this.$store.projects = []
			this.$store.services = []
		}

		if (this.$route.name == 'ProjectWithSubmenus'){
			this.showList = false
		}
	}
}
</script>

<style type="text/css" scoped>
	.close-edit {
		position: absolute;
		top: 10px;
		right: 0;
		z-index: 1;
	}
</style>